import { render, staticRenderFns } from "./WsField.vue?vue&type=template&id=530f4bb7"
import script from "./WsField.vue?vue&type=script&lang=js"
export * from "./WsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports